<template>
    <div class="order-complete">
        <div class="hero is-large">
            <div class="hero-body is-loading">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Redirecting"
    }
</script>

<style lang="scss">
    .order-complete {
        .is-loading {
            text-align: center;
            position: relative;
            overflow: hidden;

            &:after {
                -webkit-animation: spinAround 500ms infinite linear;
                animation: spinAround 500ms infinite linear;
                border: 4px solid $primary;
                border-radius: 290486px;
                border-right-color: transparent;
                border-top-color: transparent;
                content: "";
                display: block;
                height: 96px;
                width: 96px;
                left: calc(50% - (2em / 2));
                top: calc(50% - (2em / 2));
                position: absolute;
            }
        }
    }
</style>